import gql from "graphql-tag"

const SEARCH_STORES = gql`
  query searchStores($searchStoresInput: SearchStoresInput!) {
    searchStores(searchStoresInput: $searchStoresInput) {
      id
      url
    }
  }
`

export default SEARCH_STORES
